export const getSuppModalDtmData = state => state.suppModal.suppModalDtmData || '';
